import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { NoTableRowsOverlay, SideFilters } from '@retail/components';

interface Props {
  customerAssortmentSelect: ReactNode;
}

export function NoSelectedCustomerAssortment({ customerAssortmentSelect }: Props) {
  const t = useAppTFunction();

  return (
    <Stack flexGrow={1} flexDirection="row" overflow="hidden">
      <Stack flexGrow={1}>
        <NoTableRowsOverlay noRowsText={t('app.customerAssortments.pickCustomer')} />
      </Stack>
      <SideFilters showFilters sx={{ py: 1 }}>
        {customerAssortmentSelect}
      </SideFilters>
    </Stack>
  );
}
